import { z } from 'zod'
import { parsePhoneNumberFromString } from 'libphonenumber-js'


export const phoneSchema = z.string().refine(val => {
  const p = parsePhoneNumberFromString(val.trim())
  return p?.isValid() ?? false
}, {
  message: "Invalid phone number"
})
